import { render } from "./addCategoryItem.vue?vue&type=template&id=5279ee9b&scoped=true"
import script from "./addCategoryItem.vue?vue&type=script&lang=js"
export * from "./addCategoryItem.vue?vue&type=script&lang=js"

import "./addCategoryItem.vue?vue&type=style&index=0&id=5279ee9b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5279ee9b"],['__file',"src/views/brand/components/addCategoryItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5279ee9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5279ee9b', __exports__)) {
    console.log('reload')
    api.reload('5279ee9b', __exports__)
  }
  
  module.hot.accept("./addCategoryItem.vue?vue&type=template&id=5279ee9b&scoped=true", () => {
    console.log('re-render')
    api.rerender('5279ee9b', render)
  })

}


export default __exports__